export default {
  emptyNotice: 'No content temporarily',
}
